import React from 'react';
import { Link } from 'react-router-dom'

const DocumentDashboard = ( {user, item} ) => (
	<div className="mdl-card mdl-shadow--2dp">
		<div className="mdl-card__title">
			<h2 className="mdl-card__title-text">{item.data.service.name}</h2>
		</div>
		<div id="p2" className="mdl-progress mdl-js-progress mdl-progress__indeterminate"></div>
		<div className="mdl-card__supporting-text">
			{item.text ? 
			<div>
				<ul>
					<li><a href={item.data.service.url} target="_blank">{item.data.service.url}</a></li>
					<li>{item.data.company.name}</li>
				</ul>
			</div> :
			<div className="spinner">
            	<div className="rect1"></div>
            	<div className="rect2"></div>
            	<div className="rect3"></div>
            	<div className="rect4"></div>
            	<div className="rect5"></div>
          	</div>}
		</div>
		<div className="mdl-card__actions mdl-card--border">
	    <Link to={"document/"+item.id} className="mdl-button mdl-button--colored mdl-js-button mdl-js-ripple-effect">
	      Preview
	    </Link>
			<Link to={"document/"+item.id+"/edit"} className="mdl-button mdl-button--colored mdl-js-button mdl-js-ripple-effect">
	      Edit
	    </Link>
  	</div>
	</div>
)

export default DocumentDashboard



// WEBPACK FOOTER //
// ./src/components/documentDashboard.js